import { type FC, useLayoutEffect } from 'react';

import * as state from 'state';

interface Props {}

const loadScript = (src: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');

    script.src = src;
    script.async = true;

    script.onload = () => {
      resolve();
    };

    script.onerror = (_event, _source, _lineno, _colno, error) => {
      reject(error);
    };

    document.body.appendChild(script);
  });
};

const LoadScripts: FC<Props> = () => {
  useLayoutEffect(() => {
    Promise.all([
      loadScript(
        'https://js.braintreegateway.com/web/3.103.0/js/client.min.js',
      ),
      loadScript(
        'https://js.braintreegateway.com/web/3.103.0/js/paypal-checkout.min.js',
      ),
      loadScript(
        'https://js.braintreegateway.com/web/3.103.0/js/three-d-secure.min.js',
      ),
      loadScript(
        'https://js.braintreegateway.com/web/3.103.0/js/hosted-fields.min.js',
      ),
    ]).then(() => {
      state.checkoutScriptsLoaded(true);
    }, console.error);
  }, []);

  return null;
};

export default LoadScripts;
